// extracted by mini-css-extract-plugin
module.exports = {"List":"WrapperSubMenu_List__IHFFu","Button":"WrapperSubMenu_Button__J18To"};